module.exports = __webpack_public_path__ + "static/media/transactions-invert.95fcb295.svg";